import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HierarchyStateService {
  private readonly STORAGE_KEY = 'hierarchy_view_mode';
  private viewModeSubject: BehaviorSubject<boolean>;
  public viewMode$: Observable<boolean>;

  constructor() {
    const storedValue = localStorage.getItem(this.STORAGE_KEY);
    const initialValue = storedValue === 'true';
    this.viewModeSubject = new BehaviorSubject<boolean>(initialValue);
    this.viewMode$ = this.viewModeSubject.asObservable();
  }

  setViewMode(isViewMode: boolean): void {
    this.viewModeSubject.next(isViewMode);
    localStorage.setItem(this.STORAGE_KEY, String(isViewMode));
  }

  getViewMode(): boolean {
    return this.viewModeSubject.value;
  }

  isViewModeActive(caseId: string | null | undefined): boolean {
    const viewModeEnabled = this.getViewMode();
    const hasCaseId = !!caseId && caseId.trim() !== '';
    return viewModeEnabled && hasCaseId;
  }

  clearViewMode(): void {
    this.viewModeSubject.next(false);
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

